import { jsx as i } from "react/jsx-runtime";
import { Spinner as n } from "@instructure/ui-spinner";
import { View as t } from "@instructure/ui-view";
function a({
  delay: r,
  renderTitle: e = "Loading"
}) {
  return /* @__PURE__ */ i(t, { as: "div", height: "100%", width: "100%", textAlign: "center", children: /* @__PURE__ */ i(n, { renderTitle: e, size: "large", margin: "0 0 0 medium", delay: r }) });
}
export {
  a as LoadingIndicator
};
